// When page is scrolled, make the logo smaller.
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const toolbar = document.querySelector('.page__toolbar');
    const header = document.querySelector('.page__header-sticky');

    if (header) {
      const updateHeaderHeight = () => {
        document.documentElement.style.setProperty('--site-header-height', `${header.offsetHeight}px`);
      };

      updateHeaderHeight();
      window.addEventListener('resize', updateHeaderHeight, { passive: true });

      if (window.ResizeObserver) {
        new ResizeObserver(updateHeaderHeight).observe(header);
      }
    }

    if (!toolbar) {
      return;
    }

    const toggleScrolled = () => {
      toolbar.classList.toggle('is-scrolled', window.scrollY > 0);
    };

    window.addEventListener('scroll', toggleScrolled, { passive: true });
    toggleScrolled();
  });
})();
